/**
 * TMS Types - Single Source of Truth
 * Rule 15: No duplication - shared across backend and frontend
 */

// Booking types (carrier rates, BOL, shipment creation)
export * from './booking.types';

// Fleet Maintenance types
export * from './maintenance.types';

// Equipment types (trailer, vehicle, category)
export * from './equipment.types';

// Driver types (status, license, identity)
export * from './driver.types';

// Onboarding types (persona, module tiers, rate defaults, quiz)
export * from './onboarding.types';

// Carrier contract rate types (rate structure, lane match, fuel surcharge)
export * from './contract-rates.types';

// Order types (status, type, priority, cargo type, service level)
export * from './order.types';

// Shipment types (status, type, priority, tracking event taxonomy)
export * from './shipment.types';

// Dispatch types (driver assignment lifecycle)
export * from './dispatch.types';

// Compliance types (FMCSA carrier verification reason discriminator)
export * from './compliance.types';

// Geofence types (polygon/circle, category, transition event payload)
export * from './geofence.types';

// Tracking WS event names + namespaces (dispatcher + portal tracking)
export * from './tracking-ws.types';

// Equipment WS event names + payload (power-unit status relay)
export * from './equipment-ws.types';

// Dangerous goods — harmonized UN classification + regime-agnostic compliance types
export * from './dangerous-goods.types';
export * from './driver-certificate.types';
